module.exports = __webpack_public_path__ + "img/sign_bg.6e8066d8.png";